<div class="panels-sidebar">
  <div class="panel-sidebar" [ngClass]="{'active': isActive(panel)}"
       *ngFor="let panel of panels" (click)="changeStatus(panel)">
    <p>{{panel}}</p>
  </div>
</div>
